module.exports = __webpack_public_path__ + "static/dan-demo-concurrent-df57dba95c8774cbf55893a607f54d74.png";